// extracted by mini-css-extract-plugin
export default {"tabs":"nmM8Rd0Jqs","control":"uDjsd_XlAN","active":"lq9wKZLb2C","dark":"Rzuq11ISfR"};